import { ExternalTransactionTypes } from '../enum/extranal-transaction-types';
import { LiliTransaction } from '../types/lili-transaction';
import bugsnagHandler from '../../../services/bugsnag.service';

// Returns the image name for the transaction icon
export function transactionIconImageName(t: LiliTransaction): string {
  switch (t.externalTransactionType) {
    case ExternalTransactionTypes.SWIPE:
    case ExternalTransactionTypes.SWIPE_REFUND:
      return 'debit_card_transaction';

    case ExternalTransactionTypes.SWIPE_CASHBACK:
      return 'cashback_transaction';

    case ExternalTransactionTypes.PAYMENT:
    case ExternalTransactionTypes.DIRECT_DEPOSIT:
    case ExternalTransactionTypes.INCOMING_WIRE:
    case ExternalTransactionTypes.BILL_PAY:
      return 'fund_transfer_transaction';

    case ExternalTransactionTypes.ACH_TRANSFER:
      return 'ach_transaction';

    case ExternalTransactionTypes.DIRECT_DEPOSIT_HOLD:
      return 'transaction_hold';

    case ExternalTransactionTypes.ADJUSTMENT:
      return 'adjustment_transaction';

    case ExternalTransactionTypes.TAX_BUCKET_AUTO_SAVE:
    case ExternalTransactionTypes.TAX_BUCKET_MANUAL_SAVE:
      return 'tax_bucket_transaction';

    case ExternalTransactionTypes.EMERGENCY_BUCKET_AUTO_SAVE:
    case ExternalTransactionTypes.EMERGENCY_BUCKET_MANUAL_SAVE:
      return 'emergency_bucket_transaction';

    case ExternalTransactionTypes.LILI_PLAN_FEE:
    case ExternalTransactionTypes.FEE:
    case ExternalTransactionTypes.CHECK_DEPOSIT_FEE:
    case ExternalTransactionTypes.ACH_EXPRESS_FEE:
    case ExternalTransactionTypes.BILL_PAY_FEE:
      return 'fee_transaction';

    case ExternalTransactionTypes.STORE_WITHDRAWAL:
    case ExternalTransactionTypes.ATM_WITHDRAWAL:
      return 'atm_transaction';

    case ExternalTransactionTypes.REFERRAL_GIFT:
    case ExternalTransactionTypes.CAMPAIGN_GIFT:
      return 'gift_transaction';

    case ExternalTransactionTypes.CHECK_DEPOSIT:
      return 'check_deposit_transaction';

    case ExternalTransactionTypes.CHECK_DEPOSIT_REJECTED:
    case ExternalTransactionTypes.CHECK_DEPOSIT_BOUNCED:
      return 'check_deposit_rejected_transaction';

    case ExternalTransactionTypes.DEBIT_CARD_DEPOSIT:
      return 'debit_card_deposit_transaction';

    case ExternalTransactionTypes.EMERGENCY_SAVINGS_ACCOUNT_INTEREST:
      return 'emergency_savings_interest_transaction';

    case ExternalTransactionTypes.CASH_DEPOSIT:
      return 'cash_deposit_transaction';

    case ExternalTransactionTypes.DIRECT_DEPOSIT_RETURN:
      return 'direct_deposit_return_transaction';

    case ExternalTransactionTypes.MAIL_CHECK:
      return 'mail_check_transaction';

    case ExternalTransactionTypes.OUTGOING_WIRE:
      return 'wire-transfer';

    case ExternalTransactionTypes.INTERNATIONAL_OUTGOING_WIRE:
    case ExternalTransactionTypes.INTERNATIONAL_INCOMING_WIRE:
      return 'international-wire-transfer';

    default:
      bugsnagHandler.notify(`Got default transaction icon with type: ${t.externalTransactionType}`);
      return 'fund_transfer_transaction';
  }
}
